import React, { useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, Typography, Box, MenuItem, TextField 
} from '@mui/material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export default function OrderSuccessModal({ open, order, onClose, onUpdateStatus }) {
    // Por defecto sugerimos el estatus 6 (Finalizado/Entregado)
    // Ya que en un POS físico es el escenario más común tras pagar
    const [newStatus, setNewStatus] = useState(6); 

    if (!order) return null;

    return (
        <Dialog open={open} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, p: 2, textAlign: 'center' } }}>
            
            <Box sx={{ color: '#10b981', mt: 2, mb: 1 }}>
                <FontAwesomeIcon icon={faCheckCircle} size="4x" />
            </Box>
            
            <DialogTitle sx={{ pb: 1 }}>
                <Typography variant="h5" fontWeight="800" color="#0F172A">
                    ¡Pago Procesado!
                </Typography>
            </DialogTitle>
            
            <DialogContent>
                <Typography variant="body1" color="text.secondary" mb={3}>
                    El pedido <strong>#{order.id || order.code || 'N/A'}</strong> ha sido registrado bajo el estatus <strong>Aceptado</strong>.
                </Typography>
                
                <Box sx={{ bgcolor: '#f8fafc', p: 3, borderRadius: 2, border: '1px solid #e2e8f0', textAlign: 'left' }}>
                    <Typography variant="subtitle2" fontWeight="700" color="#0F172A" mb={1.5}>
                        ¿Deseas actualizar el estatus de entrega ahora?
                    </Typography>
                    
                    <TextField
                        select
                        fullWidth
                        size="small"
                        value={newStatus}
                        onChange={(e) => setNewStatus(e.target.value)}
                        variant="outlined"
                        sx={{ bgcolor: 'white' }}
                    >
                        <MenuItem value={3}>En Preparación</MenuItem>
                        <MenuItem value={4}>Listo para Entregar</MenuItem>
                        <MenuItem value={5}>En Camino (Delivery)</MenuItem>
                        <MenuItem value={6}>Entregado / Finalizado</MenuItem>
                    </TextField>
                </Box>
            </DialogContent>
            
            <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 1, mb: 2 }}>
                <Button 
                    onClick={onClose} 
                    variant="outlined" 
                    sx={{ borderRadius: 2, fontWeight: '700', color: '#64748b', borderColor: '#cbd5e1' }}
                >
                    Dejar como Aceptado
                </Button>
                <Button 
                    onClick={() => onUpdateStatus(order.id, newStatus)} 
                    variant="contained" 
                    sx={{ borderRadius: 2, fontWeight: '700', bgcolor: '#0ea5e9' }}
                >
                    Actualizar Estatus
                </Button>
            </DialogActions>
        </Dialog>
    );
}